// Widget "Paga en 3 cuotas con Addi" — Crow
// Delegación de eventos: no depende de IDs, funciona con cualquier
// cantidad de tarjetas (product page + catálogo) en la misma página.
document.addEventListener('click', function (e) {
  var toggle = e.target.closest('.cw-addi__toggle');
  if (!toggle) return;
  var root = toggle.closest('.cw-addi');
  if (!root) return;
  var panel = root.querySelector('.cw-addi__panel-wrap');
  if (!panel) return;
  var isOpen = toggle.getAttribute('aria-expanded') === 'true';
  toggle.setAttribute('aria-expanded', String(!isOpen));
  panel.classList.toggle('is-open', !isOpen);
});
